import { render, staticRenderFns } from "./packaging.vue?vue&type=template&id=9d54df70&"
import script from "./packaging.vue?vue&type=script&lang=js&"
export * from "./packaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports